import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, tone = "light", testId }) => (
  <div className="mb-14 max-w-3xl">
    <Reveal>
      <span
        className={`mb-5 inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.24em] ${
          tone === "light" ? "text-oris-moss" : "text-oris-gold"
        }`}
      >
        <span className="gold-rule" aria-hidden="true" />
        {overline}
      </span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        data-testid={testId}
        className={`font-serif text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl ${
          tone === "light" ? "text-oris-ink" : "text-oris-cream"
        }`}
      >
        {title}
      </h2>
    </Reveal>
  </div>
);

export { EASE };
